import { Controller } from '@hotwired/stimulus'

// Auto-dismisses a flash message after a fade-out.
// Usage: data-controller="flash" data-flash-delay-value="4000"
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 }, fade: { type: Number, default: 300 } }

  connect() {
    this.timer = setTimeout(() => this.#fadeOut(), this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  close() {
    this.#fadeOut()
  }

  #fadeOut() {
    this.element.style.opacity = '0'
    setTimeout(() => this.element.remove(), this.fadeValue)
  }
}
